<template>
  <div id="admin-login">
    <v-container grid-list-xl>
      <div class="resultContainer">
        <v-layout align-center fill-height justify-center row>
          <v-flex md4 sm6 text-xs-center xs10>
            <v-card elevation="12">
              <!-- <v-toolbar color="primary" dark>
                <v-toolbar-title>Login</v-toolbar-title>
                <v-spacer></v-spacer>
              </v-toolbar>-->
              <v-card-text>
                <v-text-field
                  autofocus
                  label="Email"
                  prepend-icon="email"
                  type="email"
                  v-model.trim="email"
                ></v-text-field>
                <v-text-field
                  @keyup.enter="login()"
                  label="Password"
                  prepend-icon="lock"
                  type="password"
                  v-model.trim="password"
                ></v-text-field>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn :loading="isLoading" @click.prevent="login()" color="primary">Login</v-btn>
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </div>
    </v-container>
  </div>
</template>

<script>
import firebase from 'firebase/app' // Storage
export default {
  name: 'admin-login',
  data() {
    return {
      email: '',
      password: '', //067194023
      isLoading: false
    }
  },
  methods: {
    login() {
      this.isLoading = !this.isLoading
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(
          () => {
            const currentUser = firebase.auth().currentUser.email
            localStorage.setItem('tokenAdmin', currentUser)
            this.$router.push({ name: 'admin-consulting-topic' })
            this.isLoading = !this.isLoading
          },
          err => {
            alert('Oops. ' + err.message)
            this.isLoading = !this.isLoading
          }
        )
    }
    // onSubmit() {
    //   this.isLoading = !this.isLoading
    //   setTimeout(() => {
    //     if (this.privateCode === 'Jesus@min') {
    //       localStorage.setItem('tokenAdmin', window.window.btoa(`don't tell my mom`))
    //       this.$router.push({ name: 'admin-consulting-topic' })
    //       // console.log(window.atob(localStorage.getItem('tokenAdmin')))
    //     }
    //     this.isLoading = !this.isLoading
    //   }, 500)
    // }
  }
}
</script>

<style lang="scss" scoped>
.resultContainer {
  height: 100vh;
}
</style>
